import { api } from '../../DefaultService';
import {
  ISmtpCreateProps,
  ISmtpProps,
  ISmtpUpdateParams,
  ISmtpSimpleProps,
  ISmtpChangePasswordDto,
} from './types';

const ENDPOINT = '/v1/integrations/smtp';

export const createSmtpIntegrationAsync = async (data: ISmtpCreateProps) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllSmtpIntegrationsAsync = async (): Promise<ISmtpSimpleProps[]> => {
  return await api
    .get<ISmtpSimpleProps[]>(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getSmtpIntegrationByIdAsync = async (
  id: number,
): Promise<ISmtpProps> => {
  return await api
    .get<ISmtpProps>(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateSmtpIntegrationAsync = async ({
  id,
  data,
}: ISmtpUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteSmtpIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const changeSmtpPasswordAsync = async (data: ISmtpChangePasswordDto) => {
  return await api.post(`${ENDPOINT}/changePassword`, data).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
